import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
// eslint-disable-next-line no-unused-vars
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, serverTimestamp, query, where, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import {
    IoWaterOutline,
    IoFlameOutline,
    IoTrashBinOutline,
    IoBusinessOutline,
    IoMailOutline,
    IoAddOutline,
    IoNotificationsOutline,
    IoCreateOutline,
    IoTrashOutline,
    IoArrowBack
} from 'react-icons/io5';
import './ProveedoresGeneralesScreen.css';
import { useNavigate } from 'react-router-dom';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

function ProveedoresGeneralesScreen() {
    const { userData, currentUser } = useAuth();
    const navigate = useNavigate();
    const [proveedores, setProveedores] = useState([]);
    const [loading, setLoading] = useState(true);

    // Modal State
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('add'); // 'add' or 'edit'
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        nombre: '',
        tipo: 'Agua' // Agua, Gas, Basura, Correspondencia, Otro
    });

    const isManager = userData?.rol === 'admin' || userData?.rol === 'comite';

    useEffect(() => {
        if (!userData?.condominioId) return;
        fetchProveedores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData]);

    const fetchProveedores = async () => {
        setLoading(true);
        try {
            const q = query(collection(db, 'proveedores_generales'), where('condominioId', '==', userData.condominioId));
            const snap = await getDocs(q);
            const provs = snap.docs.map(d => ({ id: d.id, ...d.data() }));

            // Sort by tipo
            provs.sort((a, b) => a.tipo.localeCompare(b.tipo));
            setProveedores(provs);
        } catch (error) {
            console.error("Error fetching proveedores", error);
        }
        setLoading(false);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (modalMode === 'add') {
                await addDoc(collection(db, 'proveedores_generales'), {
                    ...formData,
                    condominioId: userData.condominioId,
                    createdAt: serverTimestamp()
                });
            } else {
                await updateDoc(doc(db, 'proveedores_generales', editingId), {
                    nombre: formData.nombre,
                    tipo: formData.tipo
                });
            }
            setShowModal(false);
            setFormData({ nombre: '', tipo: 'Agua' });
            fetchProveedores();
            alert(`Proveedor ${modalMode === 'add' ? 'agregado' : 'actualizado'} con éxito`);
        } catch (error) {
            console.error("Error saving proveedor:", error);
            alert("Error al guardar proveedor");
        }
    };

    const handleEdit = (prov) => {
        setModalMode('edit');
        setEditingId(prov.id);
        setFormData({ nombre: prov.nombre, tipo: prov.tipo });
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("¿Seguro que deseas eliminar este proveedor?")) return;
        try {
            await deleteDoc(doc(db, 'proveedores_generales', id));
            fetchProveedores();
        } catch (error) {
            console.error("Error deleting proveedor", error);
            alert("Hubo un error al eliminar");
        }
    };

    const handleNotifyAccess = async (prov) => {
        if (!window.confirm(`¿Seguro que deseas notificar a los residentes el acceso de ${prov.nombre}?`)) return;

        try {
            // Guardamos el registro. La Cloud Function lo interceptará y enviará Push a todos los residentes
            await addDoc(collection(db, 'accesos_proveedores_generales'), {
                proveedorId: prov.id,
                proveedorNombre: prov.nombre,
                proveedorTipo: prov.tipo,
                condominioId: userData.condominioId,
                vigilanteId: currentUser.uid,
                vigilanteNombre: userData.nombre || 'Guardia',
                timestamp: serverTimestamp()
            });

            alert(`✅ Se ha notificado a los residentes sobre el ingreso de ${prov.nombre}.`);
        } catch (error) {
            console.error("Error al notificar", error);
            alert("Hubo un error al tratar de notificar el acceso");
        }
    };

    const getIconForType = (tipo) => {
        switch (tipo) {
            case 'Agua': return <IoWaterOutline size={26} color="#06b6d4" />;
            case 'Gas': return <IoFlameOutline size={26} color="#f97316" />;
            case 'Basura': return <IoTrashBinOutline size={26} color="#64748b" />;
            case 'Correspondencia': return <IoMailOutline size={26} color="#10b981" />;
            default: return <IoBusinessOutline size={26} color="#8b5cf6" />;
        }
    };

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/proveedores-generales" />

            <main className="ks-main">
                <KondoBrandHeader title="Administración" showBackButton={false} />

                <div className="ks-scroll-area">
                    <div className="proveedores-gen-container" style={{ padding: '15px 20px', maxWidth: '1000px', margin: '0 auto' }}>
                        {/* --- Hero Banner Estándar (Morado Sólido Compacto con Botón Glass) --- */}
                        <div className="app-header-sticky" style={{ padding: 0, marginBottom: '20px' }}>
                            <div className="kondo-banner-standard" style={{ 
                                background: 'linear-gradient(135deg, #7E66FC 0%, #4F46E5 100%)', 
                                margin: 0, 
                                padding: '14px 20px', 
                                minHeight: 'auto',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderRadius: '24px',
                                boxShadow: '0 8px 24px rgba(126, 102, 252, 0.15)'
                            }}>
                                <div className="banner-standard-content" style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1 }}>
                                    <button onClick={() => navigate(-1)} className="banner-back-btn-standard" aria-label="Volver">
                                        <IoArrowBack size={24} />
                                    </button>
                                    <div className="banner-standard-text">
                                        <h2 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 800, color: 'white' }}>Proveedores Generales</h2>
                                        <p style={{ margin: '4px 0 0', fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.9)', fontWeight: 500 }}>
                                            Notifica a residentes sobre servicios comunes
                                        </p>
                                    </div>
                                </div>

                                {isManager && (
                                    <button 
                                        onClick={() => {
                                            setModalMode('add');
                                            setFormData({ nombre: '', tipo: 'Agua' });
                                            setShowModal(true);
                                        }}
                                        style={{
                                            background: 'white',
                                            color: '#7E66FC',
                                            border: 'none',
                                            borderRadius: '12px',
                                            padding: '8px 16px',
                                            fontSize: '0.88rem',
                                            fontWeight: '700',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.08)',
                                            flexShrink: 0
                                        }}
                                    >
                                        <IoAddOutline size={20} />
                                        <span>Nuevo</span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="proveedores-gen-list">
                            {loading ? (
                                <div style={{ textAlign: 'center', color: '#6b7280', padding: '40px' }}>
                                    Cargando proveedores...
                                </div>
                            ) : proveedores.length === 0 ? (
                                <div style={{ textAlign: 'center', color: '#6b7280', padding: '40px' }}>
                                    No hay proveedores registrados.
                                </div>
                            ) : (
                                proveedores.map(prov => (
                                    <div key={prov.id} className="proveedor-gen-card">
                                        <div className="proveedor-gen-info">
                                            <div className="proveedor-icon-wrapper">
                                                {getIconForType(prov.tipo)}
                                            </div>
                                            <div className="proveedor-text">
                                                <h3>{prov.nombre}</h3>
                                                <span className="tipo-badge">{prov.tipo}</span>
                                            </div>
                                        </div>
                                        <div className="proveedor-actions">
                                            <button className="btn-notificar" onClick={() => handleNotifyAccess(prov)}>
                                                <IoNotificationsOutline size={20} /> Notificar Acceso
                                            </button>

                                            {isManager && (
                                                <>
                                                    <button className="btn-edit-icon" onClick={() => handleEdit(prov)}>
                                                        <IoCreateOutline size={20} />
                                                    </button>
                                                    <button className="btn-delete-icon" onClick={() => handleDelete(prov.id)}>
                                                        <IoTrashOutline size={20} />
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </main>

            {/* Modal */}
            {showModal && (
                <div className="auth-modal-overlay">
                    <div className="auth-modal">
                        <h2>{modalMode === 'add' ? 'Nuevo Proveedor' : 'Editar Proveedor'}</h2>
                        <form onSubmit={handleSave}>
                            <div className="auth-form-group">
                                <label>Nombre del Proveedor (Ej. Ciel, Gas Tomza, etc.)</label>
                                <input
                                    type="text"
                                    className="auth-input"
                                    value={formData.nombre}
                                    onChange={e => setFormData({ ...formData, nombre: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="auth-form-group">
                                <label>Tipo de Servicio</label>
                                <select
                                    className="auth-input"
                                    value={formData.tipo}
                                    onChange={e => setFormData({ ...formData, tipo: e.target.value })}
                                >
                                    <option value="Agua">Agua Embotellada</option>
                                    <option value="Gas">Gas LP</option>
                                    <option value="Basura">Recolección de Basura</option>
                                    <option value="Correspondencia">Correspondencia / Correos</option>
                                    <option value="Otro">Otro Servicio</option>
                                </select>
                            </div>
                            <div className="auth-button-group">
                                <button type="button" className="auth-btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                                <button type="submit" className="auth-btn-primary">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <KondoBottomNav activeRoute="/proveedores-generales" />
        </div>
    );
}

export default ProveedoresGeneralesScreen;
